export const ArrowRight = ({ $isDark = false }: { $isDark?: boolean }) => (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.76172 0.515625L5.37109 0.90625C5.29297 1.00391 5.29297 1.14062 5.39062 1.23828L6.95312 2.74219H0.234375C0.0976562 2.74219 0 2.85938 0 2.97656V3.52344C0 3.66016 0.0976562 3.75781 0.234375 3.75781H6.95312L5.39062 5.28125C5.29297 5.37891 5.29297 5.51562 5.37109 5.61328L5.76172 6.00391C5.85938 6.08203 5.99609 6.08203 6.09375 6.00391L8.67188 3.42578C8.75 3.32812 8.75 3.19141 8.67188 3.09375L6.09375 0.515625C5.99609 0.4375 5.85938 0.4375 5.76172 0.515625Z"
      fill={$isDark ? '#FFFFFF' : '#5A5E5A'}
    />
  </svg>
);
